import { atom } from 'recoil';

export const sessionPopupsAtom = atom<number[]>({
  key: 'sessionPopupsState',
  default: [],
});
